import React from "react";
import Carousel from "./Carousel";

const PotraitCarousel = () => {
    return <Carousel imageType="portrait" />;
};

export default PotraitCarousel;
